const COMPARE_FIELDS = [
  { name: 'image', prop: 'innerHTML' },
  { name: 'price', prop: 'innerHTML' },
  { name: 'description', prop: 'innerHTML' },
  { name: 'features', prop: 'innerHTML' },
  { name: 'dimensions', prop: 'innerHTML' },
  { name: 'name', prop: 'textContent' },
];

document.addEventListener('DOMContentLoaded', () => {
  function initProductCompare() {
    const compareSection = document.querySelector('.product-compare');

    if (!compareSection) {
      return;
    }

    function getElements() {
      const iconWrapper = compareSection.querySelector('[data-product-compare-search-icon]');
      return {
        compareToggle: compareSection.querySelector('[data-product-compare-toggle]'),
        compareMenu: compareSection.querySelector('[data-product-compare-menu]'),
        searchInput: compareSection.querySelector('[data-product-compare-search-input]'),
        collectionResults: compareSection.querySelector('[data-collection-results]'),
        storeResults: compareSection.querySelector('[data-store-results]'),
        storeResultTemplate: compareSection.querySelector('[data-store-result-template]'),
        emptyState: compareSection.querySelector('[data-empty-state]'),
        searchLoadingSpinner: iconWrapper ? iconWrapper.querySelector('.search-loading-spinner') : null,
        searchIconWrapper: iconWrapper,
      };
    }

    let elements = getElements();
    if (!elements.compareToggle || !elements.compareMenu || !elements.searchInput) {
      return;
    }

    let isDropdownOpen = false;
    let isSearching = false;
    let isSelecting = false;
    let searchDebounceTimer = null;
    const sectionId = compareSection.getAttribute('data-section-id');

    function openDropdown() {
      elements = getElements();
      if (!elements.compareMenu) return;

      requestAnimationFrame(() => {
        elements.compareMenu.classList.remove('opacity-0', 'invisible', 'pointer-events-none');
        elements.compareMenu.classList.add('opacity-100', 'visible');
        elements.compareToggle?.setAttribute('aria-expanded', 'true');
        isDropdownOpen = true;
        if (elements.searchInput) {
          setTimeout(() => elements.searchInput.focus(), 100);
        }
      });
    }

    function closeDropdown() {
      elements = getElements();
      if (!elements.compareMenu) return;

      requestAnimationFrame(() => {
        elements.compareMenu.classList.remove('opacity-100', 'visible');
        elements.compareMenu.classList.add('opacity-0', 'invisible', 'pointer-events-none');
        elements.compareToggle?.setAttribute('aria-expanded', 'false');
        isDropdownOpen = false;
      });
    }

    function toggleDropdown() {
      if (isDropdownOpen) {
        closeDropdown();
      } else {
        openDropdown();
      }
    }

    function showSearchLoading() {
      elements = getElements();
      elements.searchLoadingSpinner?.classList.remove('hidden');
      elements.searchIconWrapper?.querySelectorAll('svg').forEach((svg) => svg.classList.add('hidden'));
    }

    function hideSearchLoading() {
      elements = getElements();
      elements.searchLoadingSpinner?.classList.add('hidden');
      elements.searchIconWrapper?.querySelectorAll('svg').forEach((svg) => svg.classList.remove('hidden'));
    }

    function showContentLoading() {
      const content = compareSection.querySelector('#comparison-product-content');
      const accordions = compareSection.querySelector('#comparison-accordions');
      content?.classList.add('opacity-50', 'pointer-events-none');
      accordions?.classList.add('opacity-50', 'pointer-events-none');
    }

    function hideContentLoading() {
      const content = compareSection.querySelector('#comparison-product-content');
      const accordions = compareSection.querySelector('#comparison-accordions');
      content?.classList.remove('opacity-50', 'pointer-events-none');
      accordions?.classList.remove('opacity-50', 'pointer-events-none');
    }

    function showAllCollectionProducts() {
      elements = getElements();
      if (!elements.collectionResults || !elements.storeResults || !elements.emptyState) return;

      elements.collectionResults.querySelectorAll('li').forEach((item) => item.classList.remove('hidden'));
      elements.collectionResults.classList.remove('hidden');
      elements.storeResults.classList.add('hidden');
      elements.emptyState.classList.add('hidden');
    }

    function hideCollectionResults() {
      elements = getElements();
      elements.collectionResults?.classList.add('hidden');
    }

    function hideStoreResults() {
      elements = getElements();
      elements.storeResults?.classList.add('hidden');
    }

    function showEmptyState() {
      elements = getElements();
      if (!elements.collectionResults || !elements.storeResults || !elements.emptyState) return;

      elements.emptyState.classList.remove('hidden');
      elements.collectionResults.classList.add('hidden');
      elements.storeResults.classList.add('hidden');
    }

    function hideEmptyState() {
      elements = getElements();
      elements.emptyState?.classList.add('hidden');
    }

    async function fetchStoreWideProducts(query) {
      if (isSearching) return;

      isSearching = true;

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`
        );
        const data = await response.json();
        const products = data.resources.results.products || [];

        if (products.length > 0) {
          renderStoreResults(products);
          hideCollectionResults();
          hideEmptyState();
        } else {
          showEmptyState();
        }
      } catch (error) {
        console.error('Search failed:', error);
        showEmptyState();
      } finally {
        isSearching = false;
      }
    }

    function renderStoreResults(products) {
      elements = getElements();
      if (!elements.storeResults || !elements.storeResultTemplate) return;

      elements.storeResults.innerHTML = '';

      products.forEach((product) => {
        const li = elements.storeResultTemplate.content.firstElementChild.cloneNode(true);
        li.dataset.productHandle = product.handle;
        li.querySelector('[data-product-compare-item]').textContent = product.title;
        elements.storeResults.appendChild(li);
      });

      elements.storeResults.classList.remove('hidden');
    }

    async function handleSearch(query) {
      if (query.trim() === '') {
        showAllCollectionProducts();
        hideStoreResults();
        hideEmptyState();
      } else {
        await fetchStoreWideProducts(query);
      }

      hideSearchLoading();
    }

    function resetSearchState() {
      elements = getElements();
      if (elements.searchInput) {
        elements.searchInput.value = '';
      }
      elements.collectionResults?.querySelectorAll('li').forEach((item) => item.classList.remove('hidden'));
      elements.storeResults?.classList.add('hidden');
      elements.emptyState?.classList.add('hidden');
    }

    function copyCompareData(doc) {
      COMPARE_FIELDS.forEach(({ name, prop }) => {
        const source = doc.querySelector(`[data-compare-self-${name}]`);
        const target = compareSection.querySelector(`[data-compare-target-${name}]`);
        if (source && target) {
          target[prop] = source[prop];
        }
      });
    }

    async function selectComparisonProduct(handle) {
      if (!handle || isSelecting) return;

      closeDropdown();

      isSelecting = true;
      showContentLoading();

      try {
        // Fetch the selected product's OWN canonical page rather than passing its handle
        // as a query param on the current page: Shopify's Section Rendering API does not
        // reliably surface arbitrary custom query params back to Liquid (request.params and
        // its content_for_header fallback are both undocumented/cache-prone for this use case),
        // but `product` always correctly resolves to the URL's own handle. Only the
        // data-driven fields (image/price/name/description/features/dimensions) are copied
        // out of that response — the search dropdown/toggle here are left untouched.
        const url = new URL(window.location.origin + `/products/${handle}`);
        url.searchParams.set('sections', sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const sectionHTML = data[sectionId];

        if (!sectionHTML) {
          throw new Error(`Section HTML not found under key "${sectionId}"`);
        }

        const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        copyCompareData(doc);

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('compare_product', handle);
        window.history.pushState({}, '', newUrl.toString());

        resetSearchState();
      } catch (error) {
        console.error('Failed to load comparison product:', error);
      } finally {
        isSelecting = false;
        hideContentLoading();
      }
    }

    function handleSectionClick(event) {
      const toggle = event.target.closest('[data-product-compare-toggle]');
      if (toggle) {
        event.stopPropagation();
        toggleDropdown();
        return;
      }

      const item = event.target.closest('[data-product-compare-item]');
      if (item) {
        event.stopPropagation();
        const handle = item.closest('[data-product-handle]')?.dataset.productHandle;
        if (handle) {
          selectComparisonProduct(handle);
        }
      }
    }

    function handleSectionInput(event) {
      if (!event.target.matches('[data-product-compare-search-input]')) return;

      const query = event.target.value.trim();
      showSearchLoading();
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(() => handleSearch(query), 500);
    }

    function handleSectionKeydown(event) {
      if (event.key !== 'Enter' || !event.target.matches('[data-product-compare-search-input]')) return;

      event.preventDefault();
      clearTimeout(searchDebounceTimer);
      showSearchLoading();
      handleSearch(event.target.value.trim());
    }

    function handleDocumentClick(event) {
      elements = getElements();
      if (!elements.compareToggle || !elements.compareMenu) return;

      const isClickInside =
        elements.compareToggle.contains(event.target) || elements.compareMenu.contains(event.target);
      if (!isClickInside && isDropdownOpen) {
        closeDropdown();
      }
    }

    function handleDocumentKeydown(event) {
      if (event.key !== 'Escape' || !isDropdownOpen) return;

      closeDropdown();
      elements = getElements();
      elements.compareToggle?.focus();
    }

    // Delegated once, on nodes that survive the innerHTML swap in selectComparisonProduct —
    // avoids re-binding listeners on new content after every product selection.
    compareSection.addEventListener('click', handleSectionClick);
    compareSection.addEventListener('input', handleSectionInput);
    compareSection.addEventListener('keydown', handleSectionKeydown);
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentKeydown);

    showAllCollectionProducts();
  }

  initProductCompare();
});
